import lookupService from "services/lookup.service";
import useSWR from "swr";

export const useOrganizationLookup = () => {
  return useSWR("/Lookup/organizations", () =>
    lookupService.getOrganizations()
  );
};
